// @ts-nocheck
export default {
  es: {
    RECENTLY_SEEN: 'Vistos recientemente',
    YOUR_CART_IS_EMPTY: 'Tu carrito está vacío',
    YOUR_SHOPPING_CART: 'Tu carrito de compras',
    ACCUMULATIVE_DISCOUNT: '¡Agrega el próximo curso con',
    EXPLORE_THE_CATALOG_AND_START_ADDING_COURES:
      'Explora el catálogo y encuentra los mejores cursos para aprender nuevas habilidades',
    BUY_FOR: 'Comprar por',
    BUY_ALL_FOR: 'Llévate todo por',
    BEST_SELLER_COURSES: 'Cursos más vendidos',
    ADD_TO_CART: 'Agregar al carrito',
    REMOVE_FROM_CART: 'Quitar del carrito',
    KEEP_BUYING: 'Seguir comprando',
    BUY_NOW: 'Comprar ahora',
    TOTAL: 'Total a pagar',
    TOTAL_IN_CART: 'Subtotal',
    APPLIED_DISCOUNTS: 'Descuentos aplicados',
    APPLIED_CREDITS: 'Créditos disponibles',
    SEND_AS_GIFT: 'Enviar como regalo',
    DELETE: 'Eliminar',
    RECOMMENDED_COURSES: 'Escogidos especialmente para ti',
    AVAILABLE_PAYMENTS: 'Compra con todos los medios de pago disponibles:',
    WHATSAPP1: '¿Tienes dudas?',
    WHATSAPP2: 'Escríbenos al whatsapp hola@crehana.com',
    GO_TO_CATALOG: 'Ir al catálogo',

    YOU_HAVE: 'Tienes',
    IN_YOUR_CART: 'en tu carrito',
    ACCESS_TO_ALL_COURSES: 'más accede a todos los cursos!',
    SUMMARY: 'Resumen',
    GO_PAYMENT_METHODS: 'Otros métodos de pago',
  },
};
